<template>
  <div :class="`${theme}-theme`">
    <router-view></router-view>
  </div>
</template>

<script>
import { globalData } from './store/store';
import { mapState } from 'pinia';

export default {
  name: 'App',
  computed: {
    ...mapState(globalData, ['theme'])
  },
  methods: {
    functiongetQueryString(name) {
      let geturl = window.location.href
      let getqyinfo = geturl.split('?')[1]
      let getqys = new URLSearchParams('?' + getqyinfo)  //将参数放在URLSearchParams函数中
      return getqys.get(name);
    }
  },
  mounted() {
  }
}
</script>
